import React, { useEffect, useState } from "react";
import Card from "../../components/Card/Card";
import { toast } from "react-toastify";
import http from "../../http-common";
import {
  ButtonSet,
  Loading,
  RadioButton,
  RadioButtonGroup,
} from "carbon-components-react";
import { Undo24 } from "@carbon/icons-react";
import { Form } from "carbon-components-react";
import { useParams } from "react-router-dom";
import CancelButton from "../../components/Buttons/CancelButton";
import useCandidature from "../../hooks/useCandidature";

const ViewSelfKnowledgeQuestionnairePage = () => {
  const params = useParams();
  const [uuid] = useState(params.uuid);
  const { isLoading, candidature } = useCandidature(uuid);
  const [issues, setIssues] = useState([]);

  const getIssues = async () => {
    try {
      const response = await http.get("/self-knowledge/issues");
      setIssues(response.data);
    } catch (error) {
      toast.error("Erro ao carregar o questionário");
    }
  };

  useEffect(() => {
    getIssues();
  }, [candidature]);

  return (
    <Card title="Questionário de auto-conhecimento">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <h4>
        <strong>Candidato:</strong> {candidature.name}
      </h4>
      {candidature && candidature.questionnaire && (
        <Form>
          {issues.map((i) => (
            <div className="mt-2" key={i.issueNumber}>
              <h5>
                {i.issueNumber}. {i.description}:
              </h5>
              <RadioButtonGroup
                legend="Group Legend"
                name={"issue" + i.issueNumber}
                orientation="vertical"
                valueSelected={candidature?.questionnaire[i.id]}
              >
                {i.options.map((o) => (
                  <RadioButton
                    id={i.issueNumber + o.code}
                    key={i.issueNumber + o.code}
                    labelText={o.code + ". " + o.description}
                    value={o.id}
                    disabled={true}
                  />
                ))}
              </RadioButtonGroup>
            </div>
          ))}

          <ButtonSet className="mt-2">
            <CancelButton label="Voltar" icon={Undo24} />
          </ButtonSet>
        </Form>
      )}
    </Card>
  );
};

export default ViewSelfKnowledgeQuestionnairePage;
